import styled from "styled-components";

export const StyledContact = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export const StyledForm = styled.form`
  width: 60%;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`;

export const CaptchaInvalidLabel = styled.div`
  padding: 0;
  display: flex;
  height: 20px;
  margin-top: 2px;
  align-items: end;

  p {
    color: red;
    font-size: 10px;
  }
`;

export const ContactInput = styled.input`
  height: 24px;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 10px;
  padding-left: 10px;
  border: ${(props) =>
    props.invalid ? "2px solid red" : "1px solid lightgray"};

  &:focus {
    outline: none;
    border: ${(props) => (props.invalid ? "2px solid red" : "1px solid gray")};
  }
`;

export const ContactTextarea = styled.textarea`
  resize: none;
  outline: none;
  border: 1px solid gray;
  height: 200px;
  border-radius: 10px;
  border: 1px solid lightgray;
  margin-top: 5px;
  padding-left: 10px;
  padding-top: 10px;
`;

export const ContactSubmit = styled.input`
  margin-top: ${(props) => (props.captchaInvalid ? "0px" : "15px")};
  height: 42px;
  font-size: 14px;
  width: 100%;
  border: none;
  background-color: rgb(123, 190, 119);
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid rgb(231, 231, 231);
  color: white;
  border-radius: 10px;

  &:hover {
    cursor: pointer;
    background-color: rgb(145, 213, 141);
    transition: all 0.1s ease 0s;
  }
`;

export const ContactCheckboxContainer = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 10px;

  a {
    cursor: pointer;
    color: blue;
  }
`;

export const Spinner = styled.div`
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid gray; /* Blue */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
